import { handleImageFieldsOnPost } from '@akin-home/images/frontend';
import { UserModel } from '@akin-home/user';
import {
  createUserMutation,
  userModelToCreateGraphql,
} from '@akin-home/users/frontend';
import { useMutation, useQueryClient } from 'react-query';
import { userQueryKeys } from '.';

/** Handles the serverside creating of users */
export const useCreateUserMutation = () => {
  const client = useQueryClient();

  return useMutation(createUserMutation, {
    onSuccess: () => {
      client.invalidateQueries(userQueryKeys.lists());
      client.invalidateQueries(userQueryKeys.all_pages());
    },
  });
};

export const useCreateUser = () => {
  const create = useCreateUserMutation();

  return async (user: UserModel) => {
    const user_with_image_fields = await handleImageFieldsOnPost(user as any, {
      habitatID: user.habitatID,
    });

    const res = await create.mutateAsync({
      input: userModelToCreateGraphql(user_with_image_fields as UserModel),
    });
    return res.data.createUser;
  };
};
